var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step-header" }, [
    _c("span", { staticClass: "step-circle" }, [_vm._v(_vm._s(_vm.number))]),
    _vm._v(" "),
    _c("div", { staticClass: "step-title" }, [
      _vm._v("\n    " + _vm._s(_vm.getLangString(_vm.langStringId)) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }